import React from "react";
import Disclaimer from "./Disclaimer";

interface Props {
  // whether this section is shown
  showPresentation?: boolean;
}

export const DisclaimerSection = ({ showPresentation = false }: Props) => {
  if (!showPresentation) return null;

  return <Disclaimer />;
};
